import {Link} from "react-router-dom";
import {Badge} from "antd";
import React, {useEffect} from "react";
import {get} from "../core/request"

type NotificationBadgeProps = {
    style?: React.CSSProperties;
    countSource: string;
    reloadSignal: boolean[];
}

export default function NotificationBadge(props: NotificationBadgeProps) {

    const [count, setCount] = React.useState(0);

    useEffect(() => {
        get(props.countSource).done((c) => setCount(c.data.count))

    }, [props.reloadSignal])

    useEffect(() => {
        console.log("count", count)
    }, [count])

    return (
        <Badge size={"small"} offset={[12,-2 ]} style={{backgroundColor: "#1677ff", fontSize: "10px", ...props.style}} count={count}/>
    )
}